
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/integrations/stripe",
      function () {
        return require("private-next-pages/settings/integrations/stripe.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/integrations/stripe"])
      });
    }
  